import React, { useEffect } from 'react'
import { Card, CardBody, CardHeader, CardHeaderTitle } from '../../../../../../../_metronic/_partials/controls'
import KurbanReportDetailCardAction from './KurbanReportDetailCardAction'
import KurbanReportDetailCardInfo from './KurbanReportDetailCardInfo'
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../_redux/report/kurbanReportAction';

import { useHistory, useParams } from 'react-router-dom'
import { toastOption } from '../../../../../../../_metronic/_helpers'
import { toast } from 'react-toastify'
import { KurbanReportDetailLog } from './KurbanReportDetailLog';
import { KurbanReportDetailComment } from './KurbanReportDetailComment';
import KurbanReportDetailImage from './KurbanReportDetailImage';
import { KurbanReportStatusActions } from './KurbanReportStatusActions';
import { kurbanReportStatus, kurbanReportStatusKeys } from '../KurbanReportUIHelpers';

function KurbanReportDetailCard() {
  const { id } = useParams();
  const history = useHistory();

  const dispatch = useDispatch();
  const { actionsLoading, kurbanReportForEdit, error } = useSelector(
    (state) => ({
      actionsLoading: state.kurbanReport.actionsLoading,
      kurbanReportForEdit: state.kurbanReport.kurbanReportForEdit,
      error: state.kurbanReport.error
    }),
    shallowEqual,
  );
  if (error) {
    toast.error(error, toastOption)
  }

  useEffect(() => {
    // ? Fetch kurban-report by id
    dispatch(actions.fetchKurbanReport(id));
  }, [id]);

  // useEffect(() => {
  //   if(
  //       !actionsLoading && 
  //       kurbanReportForEdit && 
  //       kurbanReportForEdit.status &&
  //       ![kurbanReportStatusKeys.REPORTED, kurbanReportStatusKeys.FINISH].includes(kurbanReportForEdit.status)
  //     ) {
  //       history.push("/kurban/report");
  //   }
  // }, [kurbanReportForEdit]);

  function submitUpdate(updates) {
    const {image_after, image_before, ...payload} = updates;
    const formData = new FormData();

    const validStatus = kurbanReportStatus.map(({value}) => value);

    if(!payload.status) {
      payload.status = kurbanReportForEdit.status;
    }
    
    if(!validStatus.includes(payload.status)) {
      toast.error("Invalid Status", toastOption)
    }
    
    if(image_after) {
      formData.append('after_photo', image_after);
    }
    if(image_before) {
      formData.append('before_photo', image_before);
    }

    for(const key in payload) {
      formData.append(key, payload[key]);
    }

    dispatch(actions.updateStatusKurbanReport(formData, id))
    .then(() => {
      toast.success("Updated Successfully", toastOption);
      
      setTimeout(() => {
        if(kurbanReportForEdit.status !== payload.status && payload.status === kurbanReportStatusKeys.EXECUTED) {
          history.go(0);
        } else {
          history.push("/kurban/report");
        }
      }, 500) ;
    })
    .catch((error) => {
      toast.error(error, toastOption);
    });
  }


  return (
    <div className='d-flex flex-column'>
      <Card>
        <KurbanReportDetailCardInfo detailKurban={kurbanReportForEdit} />
        <KurbanReportStatusActions submitUpdate={submitUpdate} currentStatus={kurbanReportForEdit.status || ""} />
      </Card>
      <div>
        <KurbanReportDetailImage
          afterPhoto={kurbanReportForEdit.after_photo ? kurbanReportForEdit.after_photo : {}}
          beforePhoto={kurbanReportForEdit.before_photo ? kurbanReportForEdit.before_photo : {}} />
      </div>
      <div>
        <KurbanReportDetailComment commentData={kurbanReportForEdit.thk_kurban_comment ?? []} />
      </div>
      <div>
        <KurbanReportDetailLog logData={kurbanReportForEdit.thk_kurban_log ? kurbanReportForEdit.thk_kurban_log : []} />
      </div>
    </div>
  )
}

export default KurbanReportDetailCard